/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class AudioSource extends cc.AudioSource
{
    /** Fade in time in seconds */
    @property(cc.Float)
    public StartFade: number = 0.1;

    /** Fade out time in seconds */
    @property(cc.Float)
    public StopFade: number = 0.5;

    public FullVolume: number = 1.0;

    private _starting: boolean = false;
    private _stopping: boolean = false;

    protected start(): void
    {
        this.FullVolume = this.volume;
    }

    protected update(dt: number): void
    {
        this.fadeIn(dt);
        this.fadeOut(dt);
    }

    protected fadeIn(dt: number): void
    {
        if (this._starting)
        {
            if (this.volume < this.FullVolume)
            {
                this.volume += (dt * this.FullVolume) / this.StartFade;
            }
            else
            {
                this._starting = false;
                this.volume = this.FullVolume;
            }
        }
    }

    protected fadeOut(dt: number): void
    {
        if (this._stopping)
        {
            if (this.volume > 0.0)
            {
                this.volume -= (dt * this.FullVolume) / this.StopFade;
            }
            else
            {
                this._stopping = false;
                super.stop();
                this.volume = this.FullVolume;
            }
        }
    }

    public play(): void
    {
        if (this._stopping)
        {
            this._stopping = false;
            super.stop();
            return;
        }

        if (!this._starting && this.StartFade > 0)
        {
            this._starting = true;
            this.volume = 0;
        }

        super.play();
    }

    public stop(): void
    {
        if (!this.isPlaying) { return; }

        this._starting = false;

        if (this.StopFade > 0)
        {
            this._stopping = true;
        }
        else
        {
            super.stop();
        }
    }
}
